import { PropTypes } from "prop-types";
import "./profileSection.scss";

const propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
};

const ProfileSection = ({ title, content }) => {
  return (
    <div className="profile-section-card">
      <h4 className="section-title">{title}</h4>
      {content}
    </div>
  );
};

ProfileSection.propTypes = propTypes;

export default ProfileSection;
